import moment from "moment";
import React, { useEffect } from "react";
import { useHistory } from "react-router";
import { Monev } from "../../../interfaces/Monev";
import { RootState } from "../../../store/rootReducer";
import { useDispatch, useSelector } from "react-redux";
import { getMonevAsync } from "../../../reducers/monev/monev.actions";

export const FormKegiatan = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const listMonev = useSelector((state: RootState) => state.monev.listMonev);
  const isLoading = useSelector((state: RootState) => state.monev.isLoading);
  const systemAccess =  useSelector((state: RootState) => state.authorization.systemAccess);
  const detailDokumenKerjasama = useSelector((state: RootState) => state.monev.selectedDokumenKerjasama);

  const refresh = () => {
    if (detailDokumenKerjasama) {
      dispatch(getMonevAsync.request({ DOK_ID: detailDokumenKerjasama.DOK_ID }));
    }
  }

  const openKegiatan = (monev: Monev) => {
    history.push(`/monev/${monev.DOK_ID}/${monev.MONEV_ID}`);
  }

  const generateReport = (id: number) => {
    const win = window.open(`/monev/report/${id}`, "_blank");
    if (win) {
      win.focus();
    }
  }

  const renderListKegiatan = () => {
    if (listMonev.length === 0) {
      return (
        <tr>
          <td colSpan={9} style={{textAlign: 'center'}}>
            Data tidak ditemukan: &nbsp; <button className="btn btn-primary btn-xs" onClick={refresh}>Coba Perbaharui Halaman</button>
          </td>
        </tr>
      );
    }
    
    return listMonev.map((item, index) => {
      return (
        <tr key={index}>
          <td>
            {item.NAMA_KEGIATAN}<br/>
            <span className="text-muted">{item.LOKASI_KEGIATAN}</span><br/>
            <span className="text-muted">mulai {moment(item.TANGGAL_MULAI_KEGIATAN).format('DD-MM-YYYY')}</span><br/>
            <span className="text-muted">selesai {moment(item.TANGGAL_SELESAI_KEGIATAN).format('DD-MM-YYYY')}</span>
          </td>
          <th>
            <button className="btn btn-primary btn-xs" disabled={isLoading || !systemAccess['monevPartner'].ACCESS.x} onClick={() => generateReport(item.MONEV_ID)}>
              <i className="fa fa-file-pdf-o" aria-hidden="true"></i>
            </button>{" "}
            &nbsp;
            <button className="btn btn-warning btn-xs" disabled={isLoading} onClick={() => openKegiatan(item)}>
              <i className="fa fa-pencil" aria-hidden="true"></i>
            </button>
          </th>
        </tr>
      );
    })
  }

  useEffect(() => {
    refresh();
  }, [detailDokumenKerjasama])

  if (!listMonev) return (
    <React.Fragment>
      <div className="box">
        <div className="box-header with-border">
          <h3 className="box-title">Kegiatan Terkait</h3>
        </div>
        <div className="box-body">
          Sedang memuat data...
        </div>
        <div className="overlay active">
          <i className="fa fa-refresh fa-spin"></i>
        </div>
      </div>
    </React.Fragment>
  );

  return (
    <React.Fragment>
      <div className="box">
        <div className="box-header with-border">
          <h3 className="box-title">Kegiatan Terkait</h3>
        </div>
        <div className="box-body table-responsive no-padding">
          <table className="table table-hover">
            <tbody>
              {renderListKegiatan()}
            </tbody>
          </table>
        </div>
        <div className={`overlay ${isLoading ? 'active' : null}`}>
          <i className="fa fa-refresh fa-spin"></i>
        </div>
      </div>
    </React.Fragment>
  );
};
